export namespace CustomFieldTranslations {
  export const common = {
    customField: 'customField',
  };

  export const customField = {
    displayMobile: 'displayMobile',
    displayMobileTooltip: 'displayMobileTooltip',
    useDefaultValue: 'useDefaultValue',
    customFieldUseDefaultValueTooltip: 'customFieldUseDefaultValueTooltip',
    customFieldDateDefaultNotDefinedError: 'customFieldDateDefaultNotDefinedError',
    customFieldReferenceTooltip: 'customFieldReferenceTooltip',
    customFieldHideTooltip: 'customFieldHideTooltip',
    customFieldGeneratedTooltip: 'customFieldGeneratedTooltip',
  } as const;

  export const error = {
    missingCustomFieldX: 'missingCustomFieldX',
  } as const;
}
